import UserAccount from './UserAccount.mjs';
import { showElement, hideElement, query } from '../utils.mjs';
import { markdown } from 'markdown';
import WindCreekClient from "./WindCreekClient.mjs";

UserAccount.windCreekClient = new WindCreekClient();

if (query('[data-terms-of-service-page]')) {
  let termsContainer = document.querySelector('[data-terms-container]');
  UserAccount.getTermsOfService()
    .then(terms => {
      termsContainer.innerHTML = markdown.toHTML(terms);
      termsContainer.classList.remove('loading-animation');

      if (UserAccount.isLoggedIn() && UserAccount.needsToAcceptTOS()) {
        UserAccount.setStatusNeedsToAcceptTOS();
        showElement('[data-accept-tos-warning]');
        showElement('[data-terms-of-service-form]');
      }
    })
    .catch(error => {
      termsContainer.classList.remove('loading-animation');
      showElement('[data-tos-loading-failed]');
      console.log('unable to load terms of service');
      console.error(error);
      newrelic.noticeError(error);
    });

  let termsForms = document.querySelectorAll('[data-terms-of-service-form]');
  termsForms.forEach(element => {
    element.addEventListener('submit', event => {
      event.preventDefault();

      if (UserAccount.isLoggedIn() && UserAccount.needsToAcceptTOS()) {
        hideElement('[data-accept-tos-error]');

        let checkbox = event.target.querySelector('[data-accept-tos-checkbox]');

        if (!checkbox.checked) {
          showElement('[data-accept-tos-warning]');
          return false;
        }

        UserAccount.acceptTermsOfService()
          .then(result => {
            if (result === true) {
              if (UserAccount.isMiamiSite()) {
                location.href = '/my-rewards';
              } else {
                location.href = '/profile';
              }
            } else {
              showElement('[data-accept-tos-error]');
            }
          })
          .catch(result => {
            showElement('[data-accept-tos-error]');
          });
      }
    });
  });
}
